import { Component, Input } from '@angular/core';
import { MessengerService, MessageSubject } from 'src/app/core/service/messenger.service';
import { SettingService } from 'src/app/core/service/setting.service';

@Component({
  standalone: false,
  selector: 'app-case-detail-event',
  templateUrl: './case-detail-event.component.html',
  styleUrls: ['./case-detail-event.component.scss']
})
export class CaseDetailEventComponent
{
  /**
   * Subject/Patient of the case.
   */
  @Input() public member: any;

  /**
   * Data model for this component.
   */
  @Input() public model: any;

  constructor(
    private settingService: SettingService,
    private messengerService: MessengerService)
  {
  }

  /**
   * Method called after a new task has been added.
   */
  public afterTaskAdded(): void
  {
    // send message to update case history timeline (Case UI)
    this.messengerService.sendMessage(new MessageSubject('caseHistoryUpdated'));
  }
}
